import { Box, Typography, IconButton } from "@mui/material";
import { Close as CloseIcon } from '@mui/icons-material';
import OrgGraphCard from "./OrgGraphCard";
import { Profile } from "./types";
import { useTranslation } from 'react-i18next';

interface OrgGraphPanelProps {
  profile: Profile;
  onHiddenNodesChange: (hidden: Set<string>) => void;
  legendLeftOffset?: string;
  selectedDate: string | null;
  onDateChange: (date: string | null) => void;
  onGraphUpdate: (nodes: any[], edges: any[]) => void;
  geographicCompanyIds?: ReadonlySet<string> | null;
  enableIvoLicenseOverlay?: boolean;
  enableCarEntityList?: boolean;
  enableVehicleExpansion?: boolean;
  enableTenantCases?: boolean;
  onMonitoringStateChanged?: (orgNumber: string) => void;
  onClose?: () => void;
}

export default function OrgGraphPanel({ 
  profile, 
  onHiddenNodesChange, 
  legendLeftOffset, 
  selectedDate, 
  onDateChange, 
  onGraphUpdate,
  geographicCompanyIds,
  enableIvoLicenseOverlay = false,
  enableCarEntityList = false,
  enableVehicleExpansion = false,
  enableTenantCases = false,
  onMonitoringStateChanged,
  onClose 
}: OrgGraphPanelProps) {
  const { t } = useTranslation();
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ p: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, borderBottom: 1, borderColor: 'divider' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Typography variant="subtitle2" fontWeight="bold">{t('assessment.details.graph')}</Typography>
        </Box>
        {onClose && (
          <IconButton size="small" onClick={onClose} aria-label={t('common.actions.close')}>
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      <Box sx={{ flexGrow: 1, position: 'relative', overflow: 'hidden' }}>
        <OrgGraphCard 
          profile={profile} 
          onHiddenNodesChange={onHiddenNodesChange} 
          legendLeftOffset={legendLeftOffset}
          selectedDate={selectedDate} 
          onDateChange={onDateChange}
          onGraphUpdate={onGraphUpdate}
          geographicCompanyIds={geographicCompanyIds}
          enableIvoLicenseOverlay={enableIvoLicenseOverlay}
          enableCarEntityList={enableCarEntityList}
          enableVehicleExpansion={enableVehicleExpansion}
          enableTenantCases={enableTenantCases}
          onMonitoringStateChanged={onMonitoringStateChanged}
        />
      </Box>
    </Box>
  );
}
